import { loadable } from '@namespace/common';

// Added "loadable" because the odometer uses a "document" that is not suitable for SSR
export const OdometerWrapper = loadable(() => import('./Odometer'));
